import React from 'react';
import {connect} from 'react-redux';
import { 
  emptyInstallationsSection,
  emptyAnalysisSection,
  emptySessionsSection,
  emptySettingsSection,
  emptyCollectionsSection,
  emptyTransactionsSection,
  emptyKioskSection,
  fetchCollectionsFilters,
  fetchKioskFilters,
  fetchAnalysisFilters,
  fetchInstallationsFilters,
  fetchTransactionsFilters,
  fetchLiveFloorViewerFilters,
  fetchSessionsFilters,
  fetchSettingsFilters
} from '../../redux/actions';
import OrganisationDirectory from '../shared/OrganisationDirectory';

class OrganisationDirectoryMenu extends React.Component {

  mapReduxToOrgTree() {

    let props = {
      extraFilters: true,
      section: this.props.section,
      data: null,
      onChange: null,
      empty: async () => {},
      hideable: false,
      allowAll: true,
      showEmpty: false,
      includeSearchTerms: true
    }

    switch (this.props.section) {
        case "GENERAL_INSTALL":
          props.onChange = this.props.fetchInstallationsFilters
          props.data = this.props.installationsFilters
          props.extraFilters = false;
          props.empty = this.props.emptyInstallationsSection
          props.allowAll = false;
          break;

        case "GENERAL_TRANS":
          props.data = this.props.transactionsFilters
          props.onChange = this.props.fetchTransactionsFilters
          props.extraFilters = false;
          props.empty = this.props.emptyTransactionsSection
          props.allowAll = false
          break;

        case "KIOSK":
          props.data = this.props.kioskFilters
          props.onChange = this.props.fetchKioskFilters
          props.empty = this.props.emptyKioskSection
          break;

        case "GENERAL_COLLECTIONS":
          props.data = this.props.collectionsFilters
          props.onChange = this.props.fetchCollectionsFilters
          props.extraFilters = false;
          props.empty = this.props.emptyCollectionsSection
          props.allowAll = false
          break;

        case "GENERAL_SESSIONS":
          props.data = this.props.sessionsFilters
          props.onChange = this.props.fetchSessionsFilters
          props.empty = this.props.emptySessionsSection
          break;

        case "GENERAL_ANALYSIS":
          props.data = this.props.analysisFilters
          props.onChange = this.props.fetchAnalysisFilters
          props.empty = this.props.emptyAnalysisSection
          props.includeSearchTerms = false;
          break;

        case "GENERAL_COMMS":
          props.data = this.props.LiveFloorViewerFilters
          props.onChange = this.props.fetchLiveFloorViewerFilters
          break;

        default:
          props.data = this.props.settingsFilters
          props.onChange = this.props.fetchSettingsFilters
          props.empty = this.props.emptySettingsSection
          props.extraFilters = true;
          props.allowAll = false;
          props.showEmpty = true;
          props.includeSearchTerms = false;
          break;


    }
   
    return props;
  }
 
  render() {
      return (
        <div>
          { (this.props.sectionUsesOrgTree) &&
              <OrganisationDirectory
                  {...this.mapReduxToOrgTree()}
                  marginLeft={this.props.marginLeft}
                  showOrgTree={this.props.showOrgTree}
              />
          }
        </div>
      )
 }
}

const mapStateToProps = (state, ownProps) => {
	return {
    sessionsFilters: state.sessionsFilters,
    analysisFilters: state.analysisFilters,
    collectionsFilters: state.collectionsFilters,
    installationsFilters: state.installationsFilters,
    transactionsFilters: state.transactionsFilters,
    LiveFloorViewerFilters: state.LiveFloorViewerFilters,
    settingsFilters: state.settingsFilters,
    kioskFilters: state.kioskFilters
  };
};

export default connect(mapStateToProps, {
  emptyInstallationsSection,
  emptySessionsSection,
  emptySettingsSection,
  emptyTransactionsSection,
  fetchSettingsFilters,
  fetchSessionsFilters,
  emptyCollectionsSection,
  emptyAnalysisSection,
  fetchKioskFilters,
  emptyKioskSection,
  fetchCollectionsFilters,
  fetchAnalysisFilters,
  fetchInstallationsFilters,
  fetchTransactionsFilters,
  fetchLiveFloorViewerFilters,
})(OrganisationDirectoryMenu);
